var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderHeroIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 170,
    viewBox: "0 0 160 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.767 91.9536L71.0976 115.409C70.1932 116.032 69.6367 117.139 69.6367 118.246V145.23H76.5932V120.045L108.802 97.558L104.767 91.9536Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.768 91.9536L102.402 93.6142C103.237 95.8283 104.559 97.7656 106.368 99.2878L108.733 97.6272L104.768 91.9536Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.541 115.479L124.871 92.0232L120.906 97.6968L153.115 120.184V145.369H160.071V118.385C160.002 117.139 159.445 116.101 158.541 115.479Z",
    fill: "#CDCDCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 93.6142L124.871 91.9536L120.906 97.6272L123.271 99.2878C125.011 97.8348 126.402 95.8283 127.237 93.6142Z",
    fill: "#B3B3B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.261 0H111.305V79.4302H118.261V0Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.783 76.0398C113.6 76.0398 112.418 76.2474 111.305 76.5241V79.4301H118.261V76.5241C117.148 76.1782 115.966 76.0398 114.783 76.0398Z",
    fill: "#B3B3B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.782 99.5646C109.009 99.5646 104.348 94.9289 104.348 89.1861C104.348 83.4433 109.009 78.8076 114.782 78.8076C120.556 78.8076 125.217 83.4433 125.217 89.1861C125.217 94.9289 120.556 99.5646 114.782 99.5646ZM114.782 85.7266C112.835 85.7266 111.304 87.2488 111.304 89.1861C111.304 91.1234 112.835 92.6456 114.782 92.6456C116.73 92.6456 118.261 91.1234 118.261 89.1861C118.261 87.2488 116.73 85.7266 114.782 85.7266Z",
    fill: "#CDCDCD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6087 107.729H0V170H62.6087V107.729Z",
    fill: "#86C2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4609 107.729V119.353L31.3044 116.17L37.1479 119.353V107.729H25.4609Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.045 128.486H76.5234V170H153.045V128.486Z",
    fill: "#86C2FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.941 128.486V140.11L114.785 136.927L120.628 140.11V128.486H108.941Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 114.783,
    y1: 79.4074,
    x2: 114.783,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHeroIcon);
export default __webpack_public_path__ + "static/media/orderHeroIcon.1e6f0756.svg";
export { ForwardRef as ReactComponent };